import React, { useEffect, useState, lazy, Suspense } from "react"
import { BrowserRouter as AppRouter, Route, Switch, Redirect } from 'react-router-dom'
import CommonRouter from "./helper/commonRoute"
import FallbackSpinner from "./common_component/spinner/FallbackSpinner"
// import './assets/css/style.css'
import { product } from "./helper/commonApi"
import { makeRedirectUrl, removeCookie } from "./helper/commonFunction"
// import useHotjar from "./custom_hooks/useHotjar"
import { nodeSetCookie, nodeGetCookie } from './helper/axios'
import CommonApiEndPoint from "./helper/commonApiEndPoint"
import appLogo from './assets/img/Munim-Logo.svg'
const Register = lazy(() => import("./register"))
const SupportChat = lazy(() => import("./common_component/SupportChat"))

/**
 * Fetch the chunks and logo needed by the current auth page while the
 * logged-in cookie check is still in flight, instead of after it.
 */
const preloadCurrentPage = () => {
  const pathname = window.location.pathname
  const isSignIn = pathname === '/' || pathname.includes(CommonRouter.log_in) || pathname.includes('admin-login') || pathname.includes(CommonRouter.sign_up)
  const isForgotPassword = pathname.includes(CommonRouter.forgot_password)
  if (!isSignIn && !isForgotPassword) return
  const ignoreError = () => { }
  import("./register").catch(ignoreError)
  if (isSignIn) {
    import("./register/SignIn").catch(ignoreError)
  } else if (isForgotPassword) {
    import("./register/ForgotPassword").catch(ignoreError)
    if (window.matchMedia('(min-width: 992px)').matches) {
      import("./register/ReviewSlider").catch(ignoreError)
    }
  }
  new Image().src = appLogo
}

function App() {
  const [preLoading, setPreLoading] = useState(true)
  const isSupportChatEnabled = window.location.hostname === 'accounts.themunim.com' && !window.location.href.includes('is_check_storage')

  useEffect(() => {
    preloadCurrentPage()
  }, [])

  useEffect(() => {
    const initializeApp = async () => {
      const get_redirect_url = window.location.search
      const urlParams = new URLSearchParams(get_redirect_url);
      const aiDiscountParam = urlParams.get('ai_discount')
      if (aiDiscountParam != null && String(aiDiscountParam).trim() !== '') {
        localStorage.setItem('ai_discount', String(aiDiscountParam).trim())
      }
      const discount_code = window.location.pathname.split('/')[2]

      if (!get_redirect_url || (get_redirect_url && !get_redirect_url.match('is_logout') && !get_redirect_url.match('is_logged_app') && !get_redirect_url.match('is_check_storage'))) {
        // Check cookie asynchronously without blocking
        const common_data = await nodeGetCookie(`${CommonApiEndPoint.get_cookie}?key=common_data`)

        if (common_data) {
          const myParam = urlParams.get('product')
          /**
           * iw0090
           * for solution of safari hortcut and crome
            let myDynamicManifest =
           {
             "short_name": "The Munim",
             "name": "The Munim",
             "icons": [
               {
                 "src": "favicon.ico",
                 "sizes": "64x64 32x32 24x24 16x16",
                 "type": "image/x-icon"
               }
             ],
             "start_url":`${window.location.hostname}/log-in?redirect_url=${myParam}`,
             "display": "standalone",
             "theme_color": "#000000",
             "background_color": "#ffffff"
           }
           const stringManifest = JSON.stringify(myDynamicManifest);
           const blob = new Blob([stringManifest], {type: 'application/json'});
           const manifestURL = URL.createObjectURL(blob);
           document.querySelector('#my-manifest-placeholder').setAttribute('href', manifestURL);
   
           var link = document.createElement('Link');
           link.rel = "manifest";
           link.setAttribute('href', 'data:application/json;charset=8' + stringManifest) 
           */
          const redirectUrl = myParam ? product[myParam] : JSON.parse(common_data)?.logged_app || makeRedirectUrl({}, new Date(), {}, 'app').create_url
          window.open(redirectUrl, '_parent')
          return
        } else if (discount_code) {
          nodeSetCookie(CommonApiEndPoint.set_cookie, { key: "m_d_c", value: decodeURIComponent(discount_code) });
        } else {
          await nodeSetCookie(CommonApiEndPoint.remove_cookie, { key: 'common_data' })
          localStorage.removeItem('common_data')
          localStorage.removeItem('is_log')
        }
      } /* else if (get_redirect_url.match('is_logged_app')) {
        const query_search = window.location.search.split('&product=')
        const final_redirect_url = makeRedirectUrl({}, new Date(), {}, query_search[1])

        localStorage.setItem('logged_app', final_redirect_url?.redirect_url)
      } */ else if (get_redirect_url.match('is_logout')) {
        removeCookie('clarity_token')
        localStorage.removeItem('is_log')
        localStorage.removeItem('logged_app')
        localStorage.removeItem('common_data')
        const removeNodeCookie = await nodeSetCookie(CommonApiEndPoint.remove_cookie, { key: 'common_data' })
        if (removeNodeCookie === 'common_data') {
          const query_search = window.location.search.split('&')
          window.open(window.location.origin + window.location.pathname + '?' + query_search[1], '_parent')
        }
      }
      setPreLoading(false)
    }
    initializeApp()
  }, [])

  /* let callHotJar
  if (window.location.hostname === CommonServerRoute.live_account) {
    callHotJar = useHotjar()
  } */

  /* function iniFrame() {
    if (window.location.hostname !== window.parent.location.hostname) {
      // The page is in an iFrames
      document.write("Munim Application is not supported in iframe");
    } else {
      return true
    }
  } */

  /* useEffect(() => {
    // iniFrame();
    if (window.location.hostname === CommonServerRoute.live_account) {
      callHotJar()
    }
  }, []) */

  return (
    <AppRouter>
      <Suspense fallback={<FallbackSpinner />}>
        {preLoading ? (
          <FallbackSpinner />
        ) : (
          <Switch>
            <Route exact path={CommonRouter.log_in} component={Register} />
            <Route exact path={`${CommonRouter.log_in}/:token`} component={Register} />
            <Route exact path={CommonRouter.sign_in} component={Register} />
            <Route exact path={`${CommonRouter.sign_in}/:token`} component={Register} />
            <Route exact path={CommonRouter.sign_up} component={Register} />
            <Route exact path={`${CommonRouter.sign_up}/:token`} component={Register} />
            <Route exact path={CommonRouter.forgot_password} component={Register} />
            <Route exact path={`${CommonRouter.forgot_password}/:token`} component={Register} />
            <Route exact path={CommonRouter.reset_password} component={Register} />
            <Route exact path={`${CommonRouter.reset_password}/:token`} component={Register} />
            <Route exact path={`${CommonRouter.active_email}/:token`} component={Register} />
            <Route exact path={`${CommonRouter.verify_email_preference}/:token`} component={Register} />
            <Route exact path={`${CommonRouter.admin_login}/:adminToken`} component={Register} />
            <Route exact path='/' render={() => (
              <Redirect to={
                window.location.href.includes('product=gst')
                  ? `${CommonRouter.log_in}?product=gst`
                  : CommonRouter.log_in
              } />
            )} />
            <Route path='*' render={() => (
              <Redirect to={
                window.location.href.includes('product=gst')
                  ? `${CommonRouter.log_in}?product=gst`
                  : CommonRouter.log_in
              } />
            )} />
          </Switch>
        )}
      </Suspense>
      {isSupportChatEnabled && !preLoading && (
        <Suspense fallback={null}>
          <SupportChat firstLoad={preLoading} />
        </Suspense>
      )}
    </AppRouter>
  )
}

export default App
